import GoogleAd from './GoogleAd';

const BannerAds = () => (
  <div className="w-full mb-6 min-[801px]:mb-8">
    {/* Desktop ad (970x90 / 970x250) — hidden below 801px */}
    <div className="hidden min-[801px]:flex justify-center h-[250px] overflow-hidden">
      <GoogleAd
        id="ad_970x90"
        dataDfp="970x90"
        dataSizes={[[970, 90], [970, 250]]}
      />
    </div>
    {/* Mobile ad (360x60) — hidden at 801px and above */}
    <div className="flex justify-center h-[60px] overflow-hidden min-[801px]:hidden">
      <GoogleAd
        id="ad_bevnet_360_60"
        dataDfp="bevnet_360_60"
        dataSizes={[[360, 60]]}
      />
    </div>
  </div>
);

export default BannerAds;
